import { createTheme } from '@mui/material/styles';

export const customTheme = {
  palette: {
    background: {
      default: '#F1F0ED'
    }
  }
};

export const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#28334A', //Basic dploy blue
      light: '#4D4D4D',
      dark: '#000000' //Black
    },
    secondary: {
      main: '#FAF9F6', //Used for header
      light: '#E4E1DB', //Used for test model box
      dark: '#A6A6A6'
    },
    background: {
      paper: '#FFFFFF'
    },
    divider: '#D9D9D9',
    success: {
      main: '#5DD570',
      light: '#DBEEDE',
      dark: '#00594F'
    },
    warning: {
      main: '#D3882F'
    },
    error: {
      main: '#D32F2F'
    }
  },
  shape: {
    borderRadius: 5
  },
  typography: {
    h1: { fontFamily: 'Arial', fontSize: 32, fontWeight: '700' },
    h3: { fontFamily: 'Arial', fontSize: 24, fontWeight: '700' },
    h4: { fontFamily: 'Arial', fontSize: 20, fontWeight: '500' },
    body1: { fontFamily: 'Arial', fontSize: 18, fontWeight: '400' },
    body2: { fontFamily: 'Arial', fontSize: 16, fontWeight: '400' },
    caption: { fontFamily: 'Arial', fontSize: 12, fontWeight: '400' }
  },
  spacing: 10,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: 'secondary',
          fontSize: '0.8rem',
          backgroundColor: 'primary',
          fontWeight: '700',
          fontStyle: 'normal',
          fontFamily: 'Arial'
        },
        outlined: {
          backgroundColor: '#fff'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff'
        },
        notchedOutline: {
          fontWeight: 'bold' // Set the <legend> on a <fieldset> bold, so the border doesn't overlap the bold legend
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 'bold'
        }
      }
    }
  }
});
